import { FC, SVGProps } from "react";

const MinusIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"  strokeWidth="1"  strokeLinecap="round" stroke="currentcolor" {...props}>
      <line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  );
};

export default MinusIcon;
